import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IUserRole } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {}

  getPermissionRoleDetails(id: string){
    return this.http.get<IUserRole[]>(
      `${environment.baseUrl}/users/${id}/roles`
    )
  }

  updateUsersPermissionRole(id: string, request: IUserRole[]){
    return this.http.post<string>(
      `${environment.baseUrl}/users/${id}/roles`,
      request,
      {responseType: 'text' as 'json'}
    )
  }

  resetUserPassword(userId: string, password: string){
    return this.http.post<string>(
      `${environment.baseUrl}/users/reset-user-password`,
      {userId, password},
      {responseType: 'text' as 'json'}
    )
  }
}
